import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20style%20illustration%20background%2C%20abstract%20watercolor%20and%20ink%20wash%20with%20warm%20coral%20pink%20and%20cream%20gradient%2C%20subtle%20comic%20panel%20textures%2C%20soft%20dreamy%20atmosphere%2C%20artistic%20brush%20strokes%2C%20clean%20negative%20space%2C%20no%20characters%2C%20decorative%20Korean%20pattern%20elements%2C%20ethereal%20lighting%2C%20modern%20minimalist%20art%20piece&width=1920&height=900&seq=hero-bg-manhwa&orientation=landscape"
          alt="韩漫漫画网 - 热门韩漫在线阅读"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm border border-background-200/50 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
              <span className="text-xs font-label text-foreground-700 whitespace-nowrap">
                全网最快更新 · 每日新番速递
              </span>
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-foreground-50 leading-tight mb-4">
              韩漫大全
              <br />
              极速更新
              <br />
              在线畅读
            </h1>
            <p className="text-foreground-100/80 text-base md:text-lg max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              收录海量热门韩漫，每日同步韩国原版更新。
              高清全彩画质，流畅阅读体验，随时随地畅享韩漫世界。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/category/romance"
                className="px-8 py-3 bg-foreground-950 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap"
              >
                立即开始阅读
              </Link>
              <Link
                to="/about"
                className="text-foreground-50 font-label text-sm border-b border-foreground-50/40 hover:border-foreground-50 transition-colors pb-0.5 whitespace-nowrap"
              >
                了解更多 &rarr;
              </Link>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="relative w-72 h-96">
              <div className="absolute -top-4 -left-4 w-64 h-88 rounded-2xl overflow-hidden rotate-[-6deg] opacity-60">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20art%2C%20beautiful%20young%20couple%20in%20cherry%20blossom%20setting%2C%20soft%20watercolor%20style%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20illustration%2C%20clean%20white%20background%2C%20delicate%20pink%20and%20cream%20tones&width=600&height=900&seq=hero-comic-left&orientation=portrait"
                  alt="韩漫推荐"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-6 right-0 w-64 h-88 rounded-2xl overflow-hidden rotate-[3deg] z-10">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20comic%20cover%2C%20heroic%20character%20with%20magical%20powers%2C%20dynamic%20pose%2C%20epic%20illustration%2C%20Korean%20webtoon%20style%2C%20clean%20white%20background%2C%20vibrant%20golden%20and%20coral%20accents&width=600&height=900&seq=hero-comic-center&orientation=portrait"
                  alt="韩漫热门"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-2 left-8 w-64 h-88 rounded-2xl overflow-hidden rotate-[-3deg] opacity-70">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20comic%20cover%2C%20dark%20atmospheric%20noir%20style%2C%20detective%20silhouette%20in%20rain%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20illustration%2C%20clean%20white%20background%2C%20moody%20dark%20tones&width=600&height=900&seq=hero-comic-right&orientation=portrait"
                  alt="韩漫新番"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-3 text-foreground-100/60 text-xs font-label">
          <span>每日更新</span>
          <span className="w-1 h-1 rounded-full bg-accent-500"></span>
          <span>高清全彩</span>
          <span className="w-1 h-1 rounded-full bg-accent-500"></span>
          <span>极速加载</span>
        </div>
      </div>
    </section>
  );
}